/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Microsoft_Calendar_EventsInputs */

const es_tools_microsoft_calendar_events = /** @type {(inputs: Tools_Microsoft_Calendar_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obteniendo eventos de Microsoft...`)
};

const en_tools_microsoft_calendar_events = /** @type {(inputs: Tools_Microsoft_Calendar_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching Microsoft events...`)
};

/**
* | output |
* | --- |
* | "Fetching Microsoft events..." |
*
* @param {Tools_Microsoft_Calendar_EventsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_microsoft_calendar_events = /** @type {((inputs?: Tools_Microsoft_Calendar_EventsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Microsoft_Calendar_EventsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_microsoft_calendar_events(inputs)
	return en_tools_microsoft_calendar_events(inputs)
});
export { tools_microsoft_calendar_events as "tools.microsoft_calendar.events" }